<div class="btn-dropdown">
    <a
      class="title"
      (click)="toggleState($event)">
      <span
        *ngIf="image"
        style="margin-right: .2em">
        <img
          alt="img"
          width="35"
          src="{{ image }}"/>
      </span>
      <span id="{{ parentId }}">{{ listTitle }}</span>
    </a>
  <div class="container" [class.visible]="isOpen" [class.loading]="isLoading">
    <ul class="list" *ngIf="!isLoading; else loaderBlock">
      <li
        class="item"
        *ngFor="let item of items"
        (click)="itemClicked(item)">
        {{ item.label }}
      </li>
    </ul>
    <ng-template #loaderBlock>
      <div>
        <img class="image01" src="../../../../assets/images/loading-circle-colour-01.svg" width="60" height="60" />
        <img class="image02" src="../../../../assets/images/loading-circle-colour-02.svg" width="60" height="60" />
        <img class="image03" src="../../../../assets/images/loading-circle-colour-03.svg" width="60" height="60" />
      </div>
    </ng-template>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/btn-dropdown/btn-dropdown.component.html